import React from 'react';
import PropTypes from 'prop-types';
import { A } from '@contently/toolkit';
import logMixpanelEvent, { STRATEGIC_REC_STORY_CLICKED } from '../../utils/log_events';

const LinkedStory = ({ id, href, title }) => {
  return (
    <A
      id={id}
      href={href}
      title={title}
      onClick={() => {
        logMixpanelEvent(
          STRATEGIC_REC_STORY_CLICKED,
          { rec_id: id, story_title: title, story_link: href }
        );
      }}
    >
      {title}
    </A>
  );
};

LinkedStory.propTypes = {
  id: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default LinkedStory;



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/linked_story.jsx